var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "accountSettingsOverflow", staticClass: "account-settings" },
    [
      _c(
        "div",
        { staticClass: "section-account section-account-information" },
        [
          _c("div", { staticClass: "title-section" }, [
            _c("div", { staticClass: "left" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.title.main"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.title.secondary"))),
              ]),
            ]),
            _c("div", { staticClass: "right" }, [
              _vm.formInfoUserIsModified() ||
              _vm.formInfoAccountIsModified() ||
              _vm.languageIsModified()
                ? _c(
                    "div",
                    {
                      staticClass: "btn-outline-primary",
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "btn-primary", on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("dash.button.save")))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "item picture" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_vm.$t("dash.settings.account.user_picture.title"))
                ),
              ]),
            ]),
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "containerPicture" }, [
                _c("img", {
                  attrs: {
                    src: _vm.dataImage
                      ? _vm.dataImage
                      : _vm.formInfoUser.avatar &&
                        _vm.formInfoUser.avatar !== "null"
                      ? _vm.formInfoUser.avatar
                      : "img/avatar.jpg",
                  },
                }),
                _c(
                  "p",
                  { staticClass: "delete", on: { click: _vm.deletePicture } },
                  [_vm._v(_vm._s(_vm.$t("dash.button.delete")))]
                ),
                _c(
                  "label",
                  {
                    staticClass: "edit",
                    attrs: { for: "fileInput", id: "fileLabel" },
                  },
                  [_vm._v(_vm._s(_vm.$t("dash.button.modify")))]
                ),
              ]),
              _c(
                "div",
                {
                  class: {
                    dragAndDrop: true,
                    hoverFile: _vm.fileHover,
                    loadingUploadPicture: _vm.loadingUploadPicture,
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      type: "file",
                      name: "fileUpload",
                      id: "fileInput",
                      accept: "image/png, image/jpeg, image/jpg",
                      hidden: "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleAddFiles($event)
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      attrs: { for: "fileInput", id: "fileLabel" },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          _vm.handleOverrideDefault($event)
                          _vm.handleFileHover()
                        },
                        dragenter: function ($event) {
                          $event.preventDefault()
                          _vm.handleOverrideDefault($event)
                          _vm.handleFileHover()
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.handleOverrideDefault($event)
                          _vm.handleFileHoverEnd()
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          _vm.handleOverrideDefault($event)
                          _vm.handleFileHoverEnd()
                          _vm.handleAddFiles($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "content-default" }, [
                        _c("i", { staticClass: "fa-solid fa-cloud-arrow-up" }),
                        _c("p", { staticClass: "instruction" }, [
                          _c("span", { staticClass: "pink" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "dash.settings.account.user_picture.drag_and_drop.title_1"
                                )
                              )
                            ),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "dash.settings.account.user_picture.drag_and_drop.title_2"
                                )
                              ) +
                              " "
                          ),
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "dash.settings.account.user_picture.drag_and_drop.title_3"
                                )
                              ) + " "
                            ),
                          ]),
                        ]),
                        _vm._m(0),
                      ]),
                      _vm._m(1),
                      _c("div", { staticClass: "content-upload-file" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.loading")) + "..."),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "item name" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.name.title"))),
              ]),
            ]),
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-circle-user" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoUser.lastname,
                      expression: "formInfoUser.lastname",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.account.name.last_name.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoUser.lastname },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.formInfoUser,
                        "lastname",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoUser.firstname,
                      expression: "formInfoUser.firstname",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.account.name.first_name.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoUser.firstname },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.formInfoUser,
                        "firstname",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item email" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.email.title"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.email.subtitle"))),
              ]),
            ]),
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-at" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoUser.email,
                      expression: "formInfoUser.email",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.account.email.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoUser.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formInfoUser, "email", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item number" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.phone.title"))),
              ]),
            ]),
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-phone" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoUser.phone,
                      expression: "formInfoUser.phone",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.account.phone.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoUser.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formInfoUser, "phone", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item password" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.password.title"))),
              ]),
              _vm.errorPassword
                ? _c("p", { staticClass: "error" }, [
                    _c("i", {
                      staticClass: "fa-regular fa-circle-exclamation",
                    }),
                    _vm._v(_vm._s(_vm.$t(_vm.errorPassword))),
                  ])
                : _vm.statePassword == "login"
                ? _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.settings.account.password.subtitle.start")
                      ) + "."
                    ),
                  ])
                : _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.account.password.subtitle.validate"
                        )
                      ) + "."
                    ),
                  ]),
            ]),
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-key" }),
                _vm.statePassword == "login"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password.current,
                          expression: "password.current",
                        },
                      ],
                      attrs: { type: "password", placeholder: "******" },
                      domProps: { value: _vm.password.current },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.password, "current", $event.target.value)
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password.new,
                          expression: "password.new",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "dash.settings.account.password.placeholder"
                        ),
                        autocomplete: "new-password",
                      },
                      domProps: { value: _vm.password.new },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.password, "new", $event.target.value)
                        },
                      },
                    }),
              ]),
              _vm.statePassword == "login"
                ? _c(
                    "div",
                    {
                      staticClass: "btn-secondary btn",
                      on: { click: _vm.changePassword },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "dash.settings.account.password.change_password"
                          )
                        )
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "btn-secondary btn",
                      on: { click: _vm.changePassword },
                    },
                    [_vm._v(_vm._s(_vm.$t("dash.button.validate")))]
                  ),
            ]),
          ]),
          _c("div", { staticClass: "item language" }, [
            _c("div", { staticClass: "name" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("dash.settings.account.language.title"))),
              ]),
            ]),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "input" },
                [
                  _c("img", {
                    attrs: {
                      src: "img/flag/" + _vm.language + "-flag-circle.jpg",
                    },
                  }),
                  _c("SelectComponent", {
                    attrs: {
                      changeValueSelect: _vm.changeLanguage,
                      data: {
                        fr: "Français",
                        en: "English",
                        de: "Deutsch",
                        es: "Español",
                        pt: "Português",
                        it: "Italiano",
                      },
                      valueSelect: _vm.language,
                      positionY: "top",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.infoUser.admin
            ? _c("div", { staticClass: "item bitly-token" }, [
                _c("div", { staticClass: "name" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("dash.settings.account.bitly_token.title"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.settings.account.bitly_token.subtitle")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "form" }, [
                  _c("div", { staticClass: "input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formInfoAccount.bitly_token,
                          expression: "formInfoAccount.bitly_token",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "dash.settings.account.bitly_token.placeholder"
                        ),
                      },
                      domProps: { value: _vm.formInfoAccount.bitly_token },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.formInfoAccount,
                            "bitly_token",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.infoUser.admin
            ? _c("div", { staticClass: "item onboarding" }, [
                _c("div", { staticClass: "name" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("dash.settings.account.onboarding.title"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.settings.account.onboarding.subtitle")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "form" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-secondary btn",
                      staticStyle: { "margin-left": "auto", width: "50%" },
                      on: { click: _vm.restartOnboarding },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("dash.settings.account.onboarding.button")
                        )
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.isProduction
            ? _c("div", { staticClass: "item onboarding" }, [
                _c("div", { staticClass: "name" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("dash.settings.account.guided_tour.title"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.settings.account.guided_tour.subtitle")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "form" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-secondary btn",
                      staticStyle: { "margin-left": "auto", width: "50%" },
                      on: { click: _vm.restartTour },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("dash.settings.account.guided_tour.button")
                        )
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "btns-action" }, [
            _c(
              "div",
              {
                staticClass: "btn-data-account btn-secondary icon-l",
                on: { click: _vm.downloadData },
              },
              [
                _c("i", { staticClass: "fa-solid fa-download" }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("dash.settings.account.export_data")) +
                    "\n          "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "btn-delete-account btn-primary icon-l",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.deleteAccountModal.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa-solid fa-trash-can" }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("dash.settings.account.remove_account")) +
                    "\n          "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "format" }, [
      _vm._v("SVG, PNG, JPG or GIF"),
      _c("br"),
      _vm._v("(max. 800x400px)"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content-hover-file" }, [
      _c("i", { staticClass: "fa-solid fa-plus" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }